<div class="user-settings">
    <upsc-page-header [pageTitle]="'UserSettings'|translate">
        <!--<div page-actions>-->
            <!--<button mat-raised-button-->
                    <!--class="page-action"-->
                    <!--type="submit"-->
                    <!--[disabled]="!formGroup.valid"-->
                    <!--(click)="onSubmit($event, formGroup.value)">-->
                <!--{{'SaveUpdate'|translate}}-->
            <!--</button>-->
        <!--</div>-->
    </upsc-page-header>
    <ng-container [ngTemplateOutlet]="form"></ng-container>
    
    <upsc-element-blocker *ngIf="isInProgress"></upsc-element-blocker>
</div>

<ng-template #form>        
    <form [formGroup]="formGroup"           
          class="ups-form">          
          <!-- (ngSubmit) = "onSubmit($event, formGroup.value)" > - This is refreshing the page in IE -->
        <div class="form-body">
            <div class="form-sections">
                <div class="form-section user-profile">
                    <div class="form-section-header">
                        <h5 class="form-section-title">{{'UserProfile'|translate}}</h5>
                    </div>                    
                    <mat-form-field>
                        <mat-label>{{'FirstName'|translate}}</mat-label>
                        <input matInput
                               required
                               type="text"
                               formControlName="firstName">
                        <mat-error *ngIf="formGroup.controls.firstName.errors?.required">
                            <span *ngIf="formGroup.controls.firstName.errors?.required">
                            {{'FirstNameRequired'|translate}}
                        </span>
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{'LastName'|translate}}</mat-label>
                        <input matInput
                               required
                               type="text"
                               formControlName="lastName">
                        <mat-error *ngIf="formGroup.controls.lastName.errors?.required">
                            <span *ngIf="formGroup.controls.lastName.errors?.required">
                            {{'LastNameRequired'|translate}}
                        </span>
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{'EmailAddress'|translate}}</mat-label>
                        <input matInput
                               required
                               type="text"
                               formControlName="email">
                        <mat-error *ngIf="formGroup.controls.email.errors?.required">
                            <span *ngIf="formGroup.controls.email.errors?.required">
                            {{'validation.emailRequired'|translate}}
                        </span>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-section change-password">
                    <div class="form-section-header">
                        <h5 class="form-section-title">{{ 'changePassword.title' | translate }}</h5>
                    </div>
                    <upsc-change-password></upsc-change-password>
                </div>

                <div class="form-section">
                    <div class="form-section-header">
                        <h5 class="form-section-title">{{'EmailNotifications'|translate}}</h5>
                    </div>                    
                    <mat-checkbox formControlName="isAlwaysNotifySender">
                        <span>
                        {{'AlwaysNotify_Msg.MessagePart1'|translate}} <strong>{{'AlwaysNotify_Msg.Sender'|translate}}</strong>
                            {{'AlwaysNotify_Msg.MessagePart2'|translate}}</span>
                    </mat-checkbox>
                    <mat-checkbox formControlName="isAlwaysNotifyRecipient">
                        <span>
                        {{'AlwaysNotify_Msg.MessagePart1'|translate}} <strong>{{'AlwaysNotify_Msg.Recipient'|translate}}</strong>
                            {{'AlwaysNotify_Msg.MessagePart3'|translate}}</span>
                    </mat-checkbox>
                    <mat-checkbox formControlName="isAlwaysNotifyCustomRecipient">
                        <span>
                        {{'AlwaysNotify_Msg.MessagePart1'|translate}} <strong>{{'AlwaysNotify_Msg.Recipient' | translate}}</strong>
                            {{'AlwaysNotify_Msg.CustomMessage'|translate}}</span>
                    </mat-checkbox>
                </div>
                <div class="form-section">
                    <div class="form-section-header">
                        <h5 class="form-section-title">{{'PrintSettings'|translate}}</h5>
                    </div>

                    <mat-checkbox formControlName="isAlwaysUseThermal">
                        {{'ThermalPrinter'|translate}}: {{'AlwaysUse'|translate}}
                    </mat-checkbox>

                    <!-- MV3-6297: Hide Auto Quick Print option in user settings -->
                    <!-- <mat-checkbox formControlName="isAutomaticPrint">
                        {{'AutoQuickPrint'|translate}}: {{'AlwaysPopupPrintLabel'|translate}}
                    </mat-checkbox> -->
                    
                    <mat-checkbox formControlName="isAlwaysPrintReceipt">
                        {{'PrintReceipt'|translate}}: {{'AlwaysPrintReceiptAfterLabel'|translate}}
                    </mat-checkbox>
                </div>
                <div class="form-section" style="display: none;">
                    <!-- <div class="form-section-header">
                        <h5 class="form-section-title">{{'WebhookSettings'|translate}}</h5>
                    </div> -->
                    <mat-accordion>
                        <mat-expansion-panel (expanded)="true" (collapsed)="false">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="form-section-header setMargin">
                                    <h5 class="form-section-title">{{'WebhookSettings'|translate}}</h5>
                                </div>
                                <!-- <h5>{{'WebhookSettings'|translate}}</h5> -->
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                            <div class="table-wrapper" [class.responsive-table]="dtOptions.responsive">
                                <table datatable
                                    [dtOptions]="dtOptions"
                                    class="stripe fixedtable" [class.fixedtable]="isClassActive">
                                    <thead>
                                    <tr>
                                        <th>
                                            {{'Platform'|translate}}
                                        </th>
                                        <th>
                                            {{'Domain'|translate}}
                                        </th>
                                        <th class="trimheader">
                                            {{'WebhookURL'|translate}}                                            
                                        </th>
                                        <th>
                                            {{'InsuranceType'|translate}}
                                        </th>
                                        <th>
                                            {{'Status'|translate}}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody class="text-nowrap grid-rows">
                                        <tr *ngFor="let item of webhooksList">
                                        <td>
                                            {{ item.Platform }}
                                        </td>
                                        <td>
                                            <div>
                                                <span class="trimResponse">{{ item.Domain }}</span>
                                                <span>
                                                    <a [href]="'#'" class="alternative-button" 
                                                    (click)="copyToClipboard($event, item.Domain)">
                                                    <img src="assets/images/content_copy.png" class="image" width="24" height="24" role="button"/>
                                                    </a>
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <span class="trimResponse">{{ item.WebHookUrl }}</span>
                                                <span>
                                                    <a [href]="'#'" class="alternative-button" 
                                                    (click)="copyToClipboard($event, item.WebHookUrl)">
                                                    <img src="assets/images/content_copy.png" class="image" width="24" height="24" role="button"/>
                                                    </a>
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            {{ item.InsuranceType}}
                                        </td>
                                        <td>
                                            {{ item.IsActive==true?"Connected":"Disconnected" }}
                                        </td>
                                    </tr>
                                    <!-- <tr *ngIf="noRecordsFound">
                                        <td colspan="5" class="text-center">
                                            <span style="color:red;font-size:12px;"> {{'NoRecordsFound'|translate}} </span>
                                        </td>
                                     </tr> -->
                                    </tbody>
                                </table>
                                <upsc-element-blocker *ngIf="isDataLoading"></upsc-element-blocker>
                                <div class="rules">
                                    {{ 'InsuranceTypeAssistance'|translate }} 
                                    <a [href]="emailstring" target="_top">{{'InsuranceTypeAssistanceEmail'|translate}}</a>.
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <div class="form-section">
                    <div class="form-section-header">
                        <h5 class="form-section-title">{{'Terms'|translate}}</h5>
                    </div>

                    <div class="deprecated-key-values">
                        <div class="key-value">
                            <div class="key">{{'TermsOfUse'|translate}}</div>
                            <div class="value">
                                <span>{{'dateAgreed'|translate}} {{ AcceptedDate | date: (userService.isUserEU(user) ? 'dd/MM/yyyy' : 'mediumDate') }}</span>
                                <a href="#"
                                   (click)="openTermsOfUseDialog($event)">
                                    {{'View'|translate}}
                                </a>
                            </div>
                        </div>
                        <div class="key-value">
                            <div class="key">{{'TermsAndConditions'|translate}}</div>
                            <div class="value">
                                <span>{{'dateAgreed'|translate}} {{ AcceptedDate | date: (userService.isUserEU(user) ? 'dd/MM/yyyy' : 'mediumDate') }}</span>
                                <a href="#"
                                   (click)="openTermsAndConditionsDialog($event)">
                                    {{'View'|translate}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-footer">
            <div class="form-actions">
                <button mat-raised-button class="page-action" type="button" (click)="updateUser()"  [disabled]="!formGroup.valid">
                    {{'SaveUpdate'|translate}}
                </button>
            </div>
        </div>
    </form>
</ng-template>

<div class="modal fade hide"
     id="termsConditionsModal"
     tabindex="-1"
     role="dialog"
     aria-labelledby="Terms and Conditions"
     aria-hidden="true">
    <div class="modal-dialog modal-lg " role="document">
        <div class="modal-content">
            <div class="modal-header popup-header">
                <div class="row">
                    <div class="col-md-10">
                        <h4 class="modal-title">{{'PPTermsAndConditions'|translate}}</h4>
                    </div>
                    <div class="col-md-2 text-right">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body" [innerHTML]="termsConditions">
            </div>
            <div class="modal-footer">
            </div>
        </div>
    </div>
</div>
<!-- /Terms and Conditions -->
<!-- Terms of Use -->
<div class="modal fade hide"
     id="termsofUseModal"
     tabindex="-1"
     role="dialog"
     aria-labelledby="Terms of Use"
     aria-hidden="true">
    <div class="modal-dialog modal-lg " role="document">
        <div class="modal-content">
            <div class="modal-header popup-header">
                <div class="row">
                    <div class="col-md-10">
                        <h4 class="modal-title">{{'PPTermsOfUse'|translate}}</h4>
                    </div>
                    <div class="col-md-2 text-right">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body" [innerHTML]="termsofUse">
            </div>
            <div class="modal-footer">
            </div>
        </div>
    </div>
</div>
